import EcoBlock from './EcoBlock.vue'

export default EcoBlock
